import { callBackendService } from "../index";
const win: any = window;

const token = win["clientToken"];

const postCarrierTypes = async (payload: any) =>
  await callBackendService(
    `support/carrier/v1/carrier-data`,
    "post",
    payload,
    token
  );
const getCarrierCatRequest = async () =>
  await callBackendService(
    `digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=carrier_cat`,
    "get",
    "",
    token
  );

export const CarriersApi = { postCarrierTypes, getCarrierCatRequest };
